import React, { useState, useEffect } from 'react';
import { Avatar } from '@mui/material';
import Icon from '@icon-park/react/es/all';
import './Avatar.scss';
const UserAvatar = ({ name, image, marginRight = '12px', icon }) => {
    const [initials, setInitials] = useState('');
    const [avatarImage, setAvatarImage] = React.useState('');
    useEffect(() => {
        if (!!name && name.length > 1) {
            setInitials(name
                .split(' ')
                .map((n) => n[0])
                .join(''));
        }
    }, [name]);
    useEffect(() => {
        if (image) {
            setAvatarImage(image);
        }
        else {
            setAvatarImage('');
        }
    }, [image]);
    return (React.createElement("div", { className: "avatar-container", style: { marginRight } },
        React.createElement(Avatar, { alt: name, src: avatarImage }, initials),
        !!icon && (React.createElement("div", { className: "avatar-icon" },
            icon === 'reduce' && React.createElement(Icon, { type: "reduce-one", theme: "filled", size: 16, fill: "#6D7470" }),
            icon === 'check' && React.createElement(Icon, { type: "check-one", theme: "filled", size: 16, fill: "#00B93A" }),
            icon === 'close' && React.createElement(Icon, { type: "close-one", theme: "filled", size: 16, fill: "#FF1800" }),
            icon === 'star' && React.createElement(Icon, { type: "star", theme: "multi-color", size: 16, fill: ['#fff', '#FFC300'] })))));
};
export default UserAvatar;
